import { render, staticRenderFns } from "./SmartCustomerService.vue?vue&type=template&id=3090c47b&scoped=true&"
import script from "./SmartCustomerService.vue?vue&type=script&lang=js&"
export * from "./SmartCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3090c47b",
  null
  
)

export default component.exports